import React, {useRef, useState} from "react"
import styled from "styled-components"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {OptionalProps as SelectProps} from "@irati/ui/src/FormItem/Select"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import mainTheme from "@irati/ui/src/global/theme"
import ToggleButton from "@irati-web/recognition/src/components/shared/ToggleButton"
import OccasionsSelect from "./OccasionsSelect"

const StyledFlex = styled(Flex)`
  .form-group {
    margin: 0;
  }
  .col-xs-12 {
    padding: 0;
  }
`
interface Props extends InjectIntl, SelectProps {
  onChange: (selectedOption: string) => void
  occasionId?: string
}
const OccasionsSelectExtraAction: React.FC<Props> = (props) => {
  const {formatMessage} = props
  const selectRef = useRef<HTMLDivElement>(null)
  const [maxWidth, setMaxWidth] = useState(0)
  const onMenuOpen = () => {
    if (!selectRef?.current?.getBoundingClientRect()) {
      return
    }
    const newMaxWidth = window.screen.availWidth - selectRef.current.getBoundingClientRect().left - 16
    setMaxWidth(newMaxWidth)
  }
  return (
    <StyledFlex ref={selectRef}>
      <OccasionsSelect
        {...props}
        hideLabel
        flush
        styles={{
          menu: (baseStyles) => ({
            ...baseStyles,
            width: "max-content",
            maxWidth: `${maxWidth}px`
          })
        }}
        controlShouldRenderValue={false}
        isClearable={false}
        onMenuOpen={onMenuOpen}
        components={{
          DropdownIndicator: () => null,
          Placeholder: () => null,
          ValueContainer: ({children}) => children,
          Input: () => null,
          Control: (selectProps) => (
            <div {...selectProps.innerProps}>
              <ToggleButton active={selectProps.selectProps!.menuIsOpen}>
                <Icon icon={IconTypes.plus} size={10} marginRight={mainTheme.spacing.half} />
                {formatMessage({id: "platform.recognition.popup.createRecognition.addCompanyCelebration.cta"})}
              </ToggleButton>
              {selectProps.children}
            </div>
          )
        }}
      />
    </StyledFlex>
  )
}
export default injectIntl(OccasionsSelectExtraAction)
